// extracted by mini-css-extract-plugin
export default {"root":"DefaultServiceModal_root__vLpXl"};